<template>
  <div class="replies-block">
    <div class="replies-block__wrapper">
      <draggable
        class="replies-block__replies"
        filter=".replies-block__add-reply"
        :list="val.replies"
        direction="horizontal"
        @end="endDrag"
      >
        <message-reply
          class="replies-block__reply"
          v-for="reply in val.replies"
          :key="reply.uuid"
          :data="reply"
          :settings="val.options"
          @change="change($event, reply.uuid, val.uuid)"
          @delete="change($event, reply.uuid, val.uuid, true)"
        ></message-reply>
        <div class="replies-block__add-reply" v-show="val.replies.length < 10" @click="add(val)">
          <fai class="replies-block__add-reply-icon" icon="plus"></fai>
        </div>
      </draggable>
      <sw-button
        inline
        v-model="val.options.saveToUserData"
        :label="$t('view.flow.block.replies.saveToUserData')"
        class="replies-block__switch"
        @input="change($event, null, val.uuid)"
      ></sw-button>
      <div class="replies-block__inputs">
        <sel
          v-show="val.options.saveToUserData"
          v-model="val.options.storage"
          class="replies-block__reply-select"
          :label="$t('view.flow.block.data.groupStorage')"
          @input="change($event, null, val.uuid)"
        >
          <option value="database">{{ $t('common.database') }}</option>
          <option value="cache">{{ $t('common.cache') }}</option>
          <option value="context">{{ $t('common.context') }}</option>
        </sel>
        <in
          v-show="val.options.saveToUserData"
          v-model="val.options.userDataName"
          :label="$t('view.flow.block.replies.userDataName')"
          class="replies-block__reply-data"
          maxlength="32"
          @input="change($event, null, val.uuid)"
        ></in>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'blockId'],
  data () {
    return {
      val: null,
      default: {
        text: {},
        data: {
          target: null,
          value: '',
          passVariables: false,
          variables: {},
          payload: ''
        }
      }
    }
  },
  methods: {
    add (step) {
      const i = step.replies.length
      let el = JSON.parse(JSON.stringify(this.default))
      el.uuid = this.uid()
      this.$set(step.replies, i, el)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
      this.$emit('refreshActionsPos')
    },

    change (changed, uuid, stepUuid, del) {
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
      for (let i in this.val.replies) {
        if (this.val.replies[i].uuid !== uuid) continue
        if (!del) this.$set(this.val.replies, i, changed)
        else this.$delete(this.val.replies, i)
        break
      }
      this.$emit('refreshActionsPos')
    },

    endDrag (event) {
      if (event.oldIndex !== event.newIndex) {
        this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      }
    }
  },
  created () {
    this.val = this.value
    for (let locale in this.$store.state.flowLocales) {
      this.default.text[locale] = 'New reply'
    }
  }
}
</script>

<style lang="scss" scoped>
.replies-block {
  display: inline-block;

  &__replies {
    display: inline-flex;
    flex-wrap: wrap;
    flex-basis: auto;
    align-items: center;
    margin-bottom: 2px;
  }

  &__wrapper {
    display: inline-block;
  }

  &__switch {
    padding: 5px 0 0 15px;
    margin-top: 7px;
  }

  &__reply {
    margin: 5px 0;
  }

  &__inputs {
    @include alignedFlex();
    justify-content: flex-start;
  }

  &__reply-select {
    margin-top: 8px;
    padding: 3px 0 0 15px;
    width: 150px;
  }

  &__reply-data {
    margin-top: 8px;
    padding: 3px 0 0 15px;
    width: 275px;
  }

  &__add-reply {
    @include alignedFlex();
    @include flowElementShadow();
    color: $primary;
    font-size: 0.9em;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: white;
    margin-left: 5px;
    cursor: pointer;
    transition: all 0.2s ease;
    will-change: box-shadow, transform, font-size;

    &:hover {
      box-shadow: 0 0px 0px rgba(112, 112, 112, 0.12),
        0 2px 4px rgba(110, 110, 110, 0.24);
      transform: scale(1.05);
      font-size: 0.9em;
    }
  }
}
</style>
